import Cookies from 'universal-cookie';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { hasValidToken } from './authSession';

const cookies = new Cookies();
const HEARTBEAT_TIMEOUT_MS = 90000;

const getAuthorizationHeader = () => {
    const token = cookies.get('tokenR');
    if (!hasValidToken(token)) {
        return null;
    }

    return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
};

export const createAuthorizedEventSource = (url) => {
    const authorization = getAuthorizationHeader();

    if (!authorization) {
        return new EventSourcePolyfill(url);
    }

    return new EventSourcePolyfill(url, {
        withCredentials: true,
        heartbeatTimeout: HEARTBEAT_TIMEOUT_MS,
        headers: {
            Authorization: authorization,
        },
    });
};
